import Sidebar from './components/layout/Sidebar';
//import Footer from './components/layout/Footer';
import Home from './components/pages/Home';
import './App.css';
import './Style.css';
import "./App.css";
import Batches from './components/pages/Batches';
import CreateBatch from './components/pages/CreateBatch';
import BatchEdit from './components/pages/BatchEdit';
import Subscriptions from './components/pages/Subscriptions';
import CreateSubscription from './components/pages/CreateSubscription';
import SubscriptionEdit from './components/pages/SubscriptionEdit';
import Products from './components/pages/Products';
import CreateProduct from './components/pages/CreateProduct';
import UploadProductImage from './components/pages/UploadProductImage';
import Orders from './components/pages/Orders';
import OrdersUpdate from './components/pages/OrdersUpdate';
import ProductImages from './components/pages/ProductImages';
import Vehicles from './components/pages/Vehicles';
import CreateVehicle from './components/pages/CreateVehicle';
import {
  HashRouter as Router,
  Route,
  Switch,
  withRouter
} from "react-router-dom";


function App() {
  return (
    <Router>
      <div className='bg-gray-100 font-family-karla flex'>
        

        <Sidebar/>

        <Switch>

        <Route exact path="/" component={Home} />
        <Route exact path="/batches" component={Batches} />
        <Route exact path="/batch/create" component={CreateBatch}></Route>
        <Route exact path="/batch/edit/:id" component={BatchEdit} />
        <Route exact path="/subscriptions" component={Subscriptions} />
        <Route exact path="/subscription/create" component={CreateSubscription}></Route>
        <Route exact path="/subscription/edit/:id" component={SubscriptionEdit} />
        <Route exact path="/products" component={Products}></Route>
        <Route exact path="/product/create" component={CreateProduct}></Route>
        <Route exact path="/product/image/upload" component={UploadProductImage}></Route>
        <Route exact path="/product/images/list/:id/:name" component={ProductImages}></Route>
        <Route exact path="/orders" component={Orders} />
        <Route exact path="/orders/update" component={OrdersUpdate} />
        <Route exact path="/vehicles" component={Vehicles}/>
        <Route exact path="/vehicle/create" component={CreateVehicle}/>


        </Switch>
      
    </div>
    </Router>
    
  );
}

export default App;
